import PhoneScreenshot from './PhoneScreenshot'

/** CleanDock invoices — shown on the quoting & payments stage. */
const InvoicePaidScreen = () => (
  <PhoneScreenshot src="/LandingPhoneMock/Invoices.PNG" alt="CleanDock invoices" />
)

export default InvoicePaidScreen
